module.exports = __webpack_public_path__ + "static/media/bell-filled.8aae23f4.svg";